import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getPaymentMode,
  getParticularPage,
  getNext,
  getPrevious,
  createPaymentMode,
  updatePaymentMode,
  handleSearch,
} from "./thunk";
import { paymentTypes } from "../../../../Utils/constants";

const initialState = {
  paymentModes: [],
  edit: false,
  paymentMode: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingPaymentMode: false,
  loadingNext: false,
  showCreateModal: false,
  // Form persistence state
  formData: {
    name: "",
    paymentType: null,
    isActive: true,
  },
  activePaymentModeId: null,
};

export const paymentModeSlice = createSlice({
  name: "paymentMode",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    paymentModeEditSuccess: (state, action) => {
      const data = state.paymentModes.find((paymentMode) => paymentMode.id === action.payload);
      state.edit = true;
      state.formData = {
        ...data,
        paymentType: paymentTypes?.find((paymentType) => paymentType.id === data?.paymentType),
      };

      state.paymentMode = {
        ...data,
        paymentType: paymentTypes?.find((paymentType) => paymentType.id === data?.paymentType),
      };
      state.activePaymentModeId = action.payload;
    },
    resetPaymentModeForm: (state, action) => {
      if (action.payload) {
        state.formData = state.paymentMode;
      } else {
        state.formData = initialState.formData;
        state.activePaymentModeId = null;
      }
    },
    savePaymentModeForm: (state, action) => {
      state.formData = action.payload;
    },
    clearAllPaymentMode: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingPaymentMode = false;
      state.paymentMode = null;
      state.formData = initialState.formData;
      state.activePaymentModeId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createPaymentMode.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createPaymentMode.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createPaymentMode.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updatePaymentMode.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updatePaymentMode.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updatePaymentMode.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getPaymentMode.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingPaymentMode = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPaymentMode.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingPaymentMode = false;
        state.paymentModes = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPaymentMode.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingPaymentMode = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  paymentModeEditSuccess,
  savePaymentModeForm,
  resetPaymentModeForm,
  clearAllPaymentMode,
} = paymentModeSlice.actions;

export default paymentModeSlice.reducer;
